import { __, s__ } from '@design-system/i18n';
export const COOKIE_SERVICE_NAME_LIST = {
    functional: [
        {
            name: 'Twitter',
            accepted: true,
        },
        {
            name: 'Facebook',
            accepted: true,
        },
    ],
    required: [
        {
            name: 'Hivebrite',
            accepted: true,
        },
        {
            name: 'Hivebrite (flagUeNewOutdatedBrowserDetection)',
            accepted: true,
        },
        {
            name: 'Paypal',
            accepted: true,
        },
        {
            name: 'Stripe',
            accepted: true,
        },
        {
            name: 'Braintree',
            accepted: true,
        },
        {
            name: 'LinkedIn',
            accepted: true,
        },
        {
            name: 'Launch Darkly (Tracker)',
            accepted: true,
        },
        {
            name: 'Datadog',
            accepted: true,
        },
        {
            name: 'Hydra',
            accepted: true,
        },
    ],
    tracking: [
        {
            name: 'Google analytics',
            accepted: true,
        },
        {
            name: 'Amplitude (Trackers)',
            accepted: true,
        },
    ],
};
export const COOKIE_LIST = {
    functional: [
        {
            name: 'metrics_token',
            service_name: 'Twitter',
            description: `Twitter metrics_token. ${__('Purpose: Displaying Twitter feeds/posts in the Live Feed of the platform')}`,
        },
        {
            name: 'personalization_id',
            service_name: 'Twitter',
            description: `Twitter personalization_id. ${__('Purpose: Displaying Twitter feeds/posts in the Live Feed of the platform')}`,
        },
        {
            name: 'tfw_exp',
            service_name: 'Twitter',
            description: `Twitter tfw_exp. ${__('Purpose: Displaying Twitter feeds/posts in the Live Feed of the platform')}`,
        },
        {
            name: 'lang',
            service_name: 'Twitter',
            description: `Twitter lang. ${__('Purpose: Displaying Twitter feeds/posts in the Live Feed of the platform')}`,
        },
        {
            name: 'fr',
            service_name: 'Facebook',
            description: `Facebook fr. ${__('Purpose: Displaying Facebook feeds/posts in the Live Feed of the platform')}`,
        },
    ],
    required: [
        {
            name: '_hivebrite_session',
            service_name: 'Hivebrite',
            description: `_hivebrite_session. ${__('Purpose: To identify the user')}`,
        },
        {
            name: 'remember_user_token',
            service_name: 'Hivebrite',
            description: `remember_user_token. ${__('Purpose: To keep the session open')}`,
        },
        {
            name: 'cookie_consent_list_fo',
            service_name: 'Hivebrite',
            description: `cookie_consent_list_fo. ${__('Purpose: To record which cookies the user gives consent for')}`,
        },
        {
            name: 'hivebrite',
            service_name: 'Hivebrite',
            description: `hivebrite. ${__('Purpose: To record user preferences such as language')}`,
        },
        {
            name: 'hivebrite_connect_bo',
            service_name: 'Hivebrite',
            description: `hivebrite_connect_bo. ${__('Purpose: To differentiate between connected and non-connected users')}`,
        },
        {
            name: 'hivebrite_connect_fo',
            service_name: 'Hivebrite',
            description: `hivebrite_connect_fo. ${__('Purpose: To differentiate between connected and non-connected users')}`,
        },
        {
            name: 'outdated_browser_hidden',
            service_name: 'Hivebrite (flagUeNewOutdatedBrowserDetection)',
            description: `outdated_browser_hidden. ${__('Purpose: To record when outdated browser notification is closed')}`,
        },
        {
            name: 'akavpau_ppsd',
            service_name: 'Paypal',
            description: `Paypal akavpau_ppsd. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'enforce_policy',
            service_name: 'Paypal',
            description: `Paypal enforce_policy. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'LANG',
            service_name: 'Paypal',
            description: `Paypal LANG. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'nsid',
            service_name: 'Paypal',
            description: `Paypal nsid. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'ts',
            service_name: 'Paypal',
            description: `Paypal ts. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'ts_c',
            service_name: 'Paypal',
            description: `Paypal ts_c. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'tsrce',
            service_name: 'Paypal',
            description: `Paypal tsrce. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'x-cdn',
            service_name: 'Paypal',
            description: `Paypal x-cdn. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'X-PP-L7',
            service_name: 'Paypal',
            description: `Paypal X-PP-L7. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'x-pp-s',
            service_name: 'Paypal',
            description: `Paypal x-pp-s. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'X-PP-SILOVER',
            service_name: 'Paypal',
            description: `Paypal X-PP-SILOVER. ${__('Purpose: For making online payments')}`,
        },
        {
            name: '__stripe_mid',
            service_name: 'Stripe',
            description: `Stripe __stripe_mid. ${__('Purpose: For making online payments')}`,
        },
        {
            name: '__stripe_sid',
            service_name: 'Stripe',
            description: `Stripe __stripe_sid. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'last_linkein_sync',
            service_name: 'LinkedIn',
            description: `LinkedIn last_linkedin_sync. ${__('Purpose: For signing in with your LinkedIn account')}`,
        },
        {
            name: 'Launch Darkly (Tracker)',
            service_name: 'Launch Darkly (Tracker)',
            description: `Launch Darkly (Tracker). ${s__('Cookies|Used to control the release of new features')}`,
        },
        {
            name: '_dd_s',
            service_name: 'Datadog',
            description: `Datadog (Tracker) _dd_s. ${s__('Purpose: Used to monitor application health')}`,
        },
        {
            name: 'api_access_token',
            service_name: 'Hydra',
            description: `Hydra api_access_token. ${s__('Cookies|Purpose: Used to securely log you in and maintain your session.')}`,
        },
        {
            name: 'api_refresh_token',
            service_name: 'Hydra',
            description: `Hydra api_refresh_token. ${s__('Cookies|Purpose: Used to securely log you in and maintain your session.')}`,
        },
    ],
    tracking: [
        {
            name: '_ga',
            service_name: 'Google analytics',
            description: `Google analytics _ga. ${s__('Cookies|Purpose: Used to distinguish users')}`,
        },
        {
            name: '_gat',
            service_name: 'Google analytics',
            description: `Google analytics _gat. ${s__('Cookies|Purpose: Used to throttle request rate')}`,
        },
        {
            name: '_gid',
            service_name: 'Google analytics',
            description: `Google analytics _gid. ${s__('Cookies|Purpose: Used to distinguish users')}`,
        },
        {
            name: 'amp_242acf',
            service_name: 'Amplitude (Trackers)',
            description: `Amplitude (Trackers) amp_242acf. ${s__('Cookies|For gathering analytics on platform usage')}`,
        },
    ],
};
export const BO_COOKIE_SERVICE_NAME_LIST = {
    functional: [
        {
            name: 'Twitter',
            accepted: true,
        },
        {
            name: 'Facebook',
            accepted: true,
        },
    ],
    required: [
        {
            name: 'Hivebrite',
            accepted: true,
        },
        {
            name: 'Hivebrite (flagUeNewOutdatedBrowserDetection)',
            accepted: true,
        },
        {
            name: 'Paypal',
            accepted: true,
        },
        {
            name: 'Stripe',
            accepted: true,
        },
        {
            name: 'Braintree',
            accepted: true,
        },
        {
            name: 'LinkedIn',
            accepted: true,
        },
        {
            name: 'Google analytics',
            accepted: true,
        },
        {
            name: 'Looker',
            accepted: true,
        },
        {
            name: 'Jimo',
            accepted: true,
        },
        {
            name: 'Datadog',
            accepted: true,
        },
        {
            name: 'Omni',
            accepted: true,
        },
        {
            name: 'Planhat NPS',
            accepted: true,
        },
        {
            name: 'Hydra',
            accepted: true,
        },
    ],
    tracking: [
        {
            name: 'Amplitude (Trackers)',
            accepted: true,
        },
    ],
};
export const BO_COOKIE_LIST = {
    functional: [
        {
            name: 'metrics_token',
            service_name: 'Twitter',
            description: `Twitter metrics_token. ${__('Purpose: Displaying Twitter feeds/posts in the Live Feed of the platform')}`,
        },
        {
            name: 'personalization_id',
            service_name: 'Twitter',
            description: `Twitter personalization_id. ${__('Purpose: Displaying Twitter feeds/posts in the Live Feed of the platform')}`,
        },
        {
            name: 'tfw_exp',
            service_name: 'Twitter',
            description: `Twitter tfw_exp. ${__('Purpose: Displaying Twitter feeds/posts in the Live Feed of the platform')}`,
        },
        {
            name: 'lang',
            service_name: 'Twitter',
            description: `Twitter lang. ${__('Purpose: Displaying Twitter feeds/posts in the Live Feed of the platform')}`,
        },
        {
            name: 'fr',
            service_name: 'Facebook',
            description: `Facebook fr. ${__('Purpose: Displaying Facebook feeds/posts in the Live Feed of the platform')}`,
        },
    ],
    required: [
        {
            name: 'remember_backoffice_admin_token',
            service_name: 'Hivebrite',
            description: `remember_backoffice_admin_token. ${__('Purpose: Allows the admin session to remain active, without asking you to connect again')}`,
        },
        {
            name: 'search_path',
            service_name: 'Hivebrite',
            description: `search_path. ${__('Purpose: Used for the user search in the BO and when you assign user to a role')}`,
        },
        {
            name: '_hivebrite_session',
            service_name: 'Hivebrite',
            description: `_hivebrite_session. ${__('Purpose: To identify the user')}`,
        },
        {
            name: 'cookie_consent_list_bo',
            service_name: 'Hivebrite',
            description: `cookie_consent_list_bo. ${__('Purpose: To record which cookies the user gives consent for')}`,
        },
        {
            name: 'hivebrite',
            service_name: 'Hivebrite',
            description: `hivebrite. ${__('Purpose: To record user preferences such as language')}`,
        },
        {
            name: 'hivebrite_connect_bo',
            service_name: 'Hivebrite',
            description: `hivebrite_connect_bo. ${__('Purpose: To differentiate between connected and non-connected users')}`,
        },
        {
            name: 'hivebrite_connect_fo',
            service_name: 'Hivebrite',
            description: `hivebrite_connect_fo. ${__('Purpose: To differentiate between connected and non-connected users')}`,
        },
        {
            name: 'outdated_browser_hidden',
            service_name: 'Hivebrite (flagUeNewOutdatedBrowserDetection)',
            description: `outdated_browser_hidden. ${__('Purpose: To record when notification of outdated browser is closed')}`,
        },
        {
            name: 'akavpau_ppsd',
            service_name: 'Paypal',
            description: `Paypal akavpau_ppsd. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'enforce_policy',
            service_name: 'Paypal',
            description: `Paypal enforce_policy. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'LANG',
            service_name: 'Paypal',
            description: `Paypal LANG. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'nsid',
            service_name: 'Paypal',
            description: `Paypal nsid. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'ts',
            service_name: 'Paypal',
            description: `Paypal ts. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'ts_c',
            service_name: 'Paypal',
            description: `Paypal ts_c. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'tsrce',
            service_name: 'Paypal',
            description: `Paypal tsrce. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'x-cdn',
            service_name: 'Paypal',
            description: `Paypal x-cdn. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'X-PP-L7',
            service_name: 'Paypal',
            description: `Paypal X-PP-L7. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'x-pp-s',
            service_name: 'Paypal',
            description: `Paypal x-pp-s. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'X-PP-SILOVER',
            service_name: 'Paypal',
            description: `Paypal X-PP-SILOVER. ${__('Purpose: For making online payments')}`,
        },
        {
            name: '__stripe_mid',
            service_name: 'Stripe',
            description: `Stripe __stripe_mid. ${__('Purpose: For making online payments')}`,
        },
        {
            name: '__stripe_sid',
            service_name: 'Stripe',
            description: `Stripe __stripe_sid. ${__('Purpose: For making online payments')}`,
        },
        {
            name: 'last_linkein_sync',
            service_name: 'LinkedIn',
            description: `LinkedIn last_linkedin_sync. ${__('Purpose: For signing in with your LinkedIn account')}`,
        },
        {
            name: '_ga',
            service_name: 'Google analytics',
            description: `Google analytics _ga. ${s__('Cookies|Purpose: Used to distinguish users')}`,
        },
        {
            name: '_gat',
            service_name: 'Google analytics',
            description: `Google analytics _gat. ${s__('Cookies|Purpose: Used to throttle request rate')}`,
        },
        {
            name: '_gid',
            service_name: 'Google analytics',
            description: `Google analytics _gid. ${s__('Cookies|Purpose: Used to distinguish users')}`,
        },
        {
            name: 'Launch Darkly (Tracker)',
            service_name: 'Launch Darkly (Tracker)',
            description: `Launch Darkly (Tracker). ${s__('Cookies|Used to control the release of new features')}`,
        },
        {
            name: '_dd_s',
            service_name: 'Datadog',
            description: `Datadog (Tracker) _dd_s. ${s__('Cookies|Purpose: Used to monitor application health')}`,
        },
        {
            name: 'Looker',
            service_name: 'Looker',
            description: `Looker (rack.session, session_timeout_data, last_heartbeat, looker.sameSite, looker.session_renewable, looker.browser, looker.expires_at, CSRF-TOKEN). ${s__('Cookies|purpose: Data visualization tool used in the Analytics module. Cookies allow the admin session to remain active & secured for navigating through the module')}`,
        },
        {
            name: 'Omni',
            service_name: 'Omni',
            description: `Omni (__omni_app_session_by_org, __omni_csrf, __omni_embed_sso_presence, __omni_session_by_org, __omni_token_by_org). ${s__('Cookies|purpose: Data visualization tool used in the Analytics module. Cookies allow the admin session to remain active & secured for navigating through the module')}`,
        },
        {
            name: 'planhat_nps',
            service_name: 'Planhat NPS',
            description: `Planhat NPS planhat_nps. ${__('Purpose: Displaying Net Promoter Score surveys to gather your feedback')}`,
        },
        {
            name: 'Jimo',
            service_name: 'Jimo',
            description: `Jimo. ${s__('Purpose: Knowledge and Communications tool used to present Hivebrite features, updates and events. Cookies allow the modals, resource menus, tooltips and other content to be displayed per admin.')}`,
        },
        {
            name: 'api_access_token',
            service_name: 'Hydra',
            description: `Hydra api_access_token. ${s__('Cookies|Purpose: Used to securely log you in and maintain your session.')}`,
        },
        {
            name: 'api_refresh_token',
            service_name: 'Hydra',
            description: `Hydra api_refresh_token. ${s__('Cookies|Purpose: Used to securely log you in and maintain your session.')}`,
        },
        {
            name: 'api_access_token_admin',
            service_name: 'Hydra',
            description: `Hydra api_access_token_admin. ${s__('Cookies|Purpose: Used to securely log you in and maintain your session.')}`,
        },
        {
            name: 'api_refresh_token_admin',
            service_name: 'Hydra',
            description: `Hydra api_refresh_token_admin. ${s__('Cookies|Purpose: Used to securely log you in and maintain your session.')}`,
        },
    ],
    tracking: [
        {
            name: 'amp_242acf',
            service_name: 'Amplitude (Trackers)',
            description: `Amplitude (Trackers) amp_242acf. ${s__('Cookies|For gathering analytics on platform usage')}`,
        },
    ],
};
//# sourceMappingURL=cookieList.js.map